// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__pzfuj","inner":"styles_inner__9QKzt","progress":"styles_progress__zN0k+","text":"styles_text__RAN-z"};